<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4 style="max-width: 500px; max-height: 600px">
        <v-card class="elevation-12 card" style="border: 10px solid #05523e">
          <v-stepper v-model="step">
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-icon
                  size="30"
                  @click="$router.go(-1)"
                  style="
                    position: absolute;
                    left: 20px;
                    top: 20px;
                    color: #05523e;
                  "
                  >mdi-arrow-left-thick</v-icon
                >
                <div style="padding: 60px">
                  <div
                    style="
                      font-size: 40px;
                      font-weight: bold;
                      color: #05523e;
                      margin: 10px auto;
                    "
                  >
                    <div style="height: 48px">Find your</div>
                    <div>Password</div>
                  </div>
                  <div
                    style="
                      color: #929292;
                      font-size: 18px;
                      font-weight: 500;
                      margin-bottom: 20px;
                    "
                  >
                    Enter the email you entered when you signed up.
                  </div>
                  <input
                    class="email"
                    v-model="email"
                    @input="emailValidation"
                    v-on:keyup.enter="sendEmail"
                  />
                  <p style="color: red; margin: 3px 0 0 7px; font-size: 13px">
                    {{ this.emailMessage }}
                  </p>

                  <v-btn
                    fontColor
                    class="white--text elevation-0 buttons"
                    color="#05523E"
                    style="
                      width: 100%;
                      height: 50px;
                      font-size: 18px;
                      font-weight: bold;
                      margin: 20px auto;
                    "
                    @click="sendEmail"
                  >
                    SEND
                  </v-btn>
                </div>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-icon
                  size="30"
                  @click="step = 1"
                  style="
                    position: absolute;
                    left: 20px;
                    top: 20px;
                    color: #05523e;
                  "
                  >mdi-arrow-left-thick</v-icon
                >
                <div style="padding: 60px">
                  <div
                    style="font-size: 40px; font-weight: bold; color: #05523e"
                  >
                    <div style="height: 48px">Enter</div>
                    <div>Verification code</div>
                  </div>
                  <div
                    style="
                      color: #929292;
                      font-size: 18px;
                      font-weight: 500;
                      margin-bottom: 20px;
                    "
                  >
                    A verification code has been to your email. please enter it
                    to verify your email.
                  </div>
                  <input class="email" v-model="code" @input="codeValidation" />
                  <p style="color: red; margin: 3px 0 0 7px; font-size: 13px">
                    {{ this.codeMessage }}
                  </p>
                  <v-btn
                    fontColor
                    class="white--text elevation-0 buttons"
                    color="#05523E"
                    style="
                      width: 100%;
                      height: 50px;
                      font-size: 18px;
                      font-weight: bold;
                      margin: 20px auto;
                    "
                    @click="verifyCode"
                  >
                    SEND
                  </v-btn>
                </div>
              </v-stepper-content>

              <v-stepper-content step="3">
                <v-icon
                  size="30"
                  @click="step = 2"
                  style="
                    position: absolute;
                    left: 20px;
                    top: 20px;
                    color: #05523e;
                  "
                  >mdi-arrow-left-thick</v-icon
                >
                <div style="padding: 60px">
                  <div
                    style="font-size: 40px; font-weight: bold; color: #05523e"
                  >
                    New Password
                  </div>
                  <div
                    style="
                      color: #929292;
                      font-size: 18px;
                      font-weight: 500;
                      margin-bottom: 20px;
                    "
                  >
                    Please enter a new password.
                  </div>
                  <input
                    class="email password"
                    placeholder="New password"
                    v-model="newPw"
                    @input="inputPw"
                  />
                  <p style="color: red; margin: 3px 0 0 7px; font-size: 13px">
                    {{ this.newPwMessage }}
                  </p>
                  <input
                    class="email"
                    placeholder="Re-password"
                    v-model="rePw"
                    @input="matchPw"
                  />
                  <p style="color: red; margin: 3px 0 0 7px; font-size: 13px">
                    {{ this.rePwMessage }}
                  </p>
                  <v-btn
                    fontColor
                    class="white--text elevation-0 buttons"
                    color="#05523E"
                    style="
                      width: 100%;
                      height: 50px;
                      font-size: 18px;
                      font-weight: bold;
                      margin: 20px auto;
                    "
                    @click="newPassword"
                  >
                    Change Password
                  </v-btn>
                </div>
              </v-stepper-content>
              <v-stepper-content step="4">
                <v-icon
                  size="30"
                  @click="step = 3"
                  style="
                    position: absolute;
                    left: 20px;
                    top: 20px;
                    color: #05523e;
                  "
                  >mdi-arrow-left-thick</v-icon
                >
                <div style="padding: 60px">
                  <div
                    style="font-size: 40px; font-weight: bold; color: #05523e"
                  >
                    <div style="height: 48px">Password</div>
                    <div style="height: 48px">Change</div>
                    <div>Complete</div>
                  </div>
                  <div
                    style="
                      color: #929292;
                      font-size: 18px;
                      font-weight: 500;
                      margin: 10px auto 25px;
                    "
                  >
                    Log in with a new password.
                  </div>
                  <v-btn
                    fontColor
                    class="white--text elevation-0 buttons"
                    color="#05523E"
                    style="
                      width: 100%;
                      height: 50px;
                      font-size: 18px;
                      font-weight: bold;
                      margin: 20px auto;
                    "
                    @click="logIn"
                  >
                    LOGIN
                  </v-btn>
                </div>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { runGqlMutation, runGqlQuery } from "@/graphql/gqlUtil.js";
import {
  CREATEEMAILCODE,
  UPDATEADMINNEW,
  CHECKEMAILCODE,
} from "@/graphql/AccountMutations.js";

export default {
  data() {
    return {
      step: 1,
      email: "",
      emailMessage: "",
      code: "",
      codeMessage: "",
      newPw: "",
      newPwMessage: "",
      rePw: "",
      rePwMessage: "",
      realCode: "",
      userId: "",
      userNo: null,
    };
  },
  methods: {
    async emailValidation() {
      if (
        await !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.email)
      ) {
        this.emailMessage = "E-mail must be valid";
      } else {
        this.emailMessage = "";
      }
    },
    async sendEmail() {
      if (this.emailMessage !== "" || this.email.length === 0) {
        this.emailMessage = "required";
        return;
      }
      const emailResult = await runGqlMutation(CREATEEMAILCODE, {
        Email: this.email,
      });
      if (emailResult.message === undefined) {
        this.realCode = emailResult.createEmailCode.Code;
        // this.userId = emailResult.createEmailCode.Admin.ID;
        this.step = 2;
      } else {
        await this.$store.commit("common/snackErrOn", {
          text: "No matching email.",
        });
      }
    },
    async codeValidation() {
      if (this.code.length !== 6) {
        this.codeMessage = "Please enter 6 characters";
      } else {
        this.codeMessage = "";
      }
    },
    async verifyCode() {
      const checkEmail = await runGqlQuery(CHECKEMAILCODE, {
        Email: this.email,
        Code: this.code,
      });
      console.log(checkEmail);
      if (checkEmail.message === undefined) {
        // check 성공
        this.userId = checkEmail.checkEmailCode.Admin.ID;
        this.userNo = checkEmail.checkEmailCode.Admin._id;
        this.step = 3;
      } else {
        await this.$store.commit("common/snackErrOn", {
          text: checkEmail.message,
        });
      }
      //   if (this.code.length === 6 && this.code === this.realCode) {
      //     this.step = 3;
      //   } else {
      //     await this.$store.commit("common/snackErrOn", { text: "Wrong code." });
      //   }
    },
    async inputPw() {
      if (this.newPw.length < 6) {
        this.newPwMessage = "Please enter 6 characters";
      } else {
        this.newPwMessage = "";
      }
    },
    async matchPw() {
      if (this.newPw !== this.rePw) {
        this.rePwMessage = "No matching Password";
      } else {
        this.rePwMessage = "";
      }
    },
    async newPassword() {
      if (this.newPw.length >= 6 && this.newPw === this.rePw) {
        const req = {
          _id: this.userNo,
          ID: this.userId,
          NewPasswd: this.newPw,
          Email: this.email,
        };
        this.editEmployee(req);
      }
    },
    async editEmployee(req) {
      try {
        const updateResult = await runGqlMutation(UPDATEADMINNEW, req);
        if (
          updateResult !== undefined &&
          updateResult.updateNewPasswd.ResultCount !== 0
        ) {
          await this.$emit("getEmployeeList");
          this.$store.commit("common/snackOn", {
            text: "Edit Password Success!",
          });
          this.step = 4;
        } else {
          this.$store.commit("common/snackErrOn", {
            text: "Edit Password Failed!",
          });
        }
      } catch (err) {
        console.error(err);
      }
    },
    async logIn() {
      try {
        this.$router.push({ name: "Login" });
      } catch (err) {
        console.error("logIn" + err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.email {
  padding-left: 10px;
  font-size: 17px;
  width: 100%;
  height: 50px;
  border: 2px solid #05523e;
}
.password {
  margin-bottom: 20px;
}
</style>
